(function() {
  const paramsToRemove = ['_pos', '_psq', '_ss', '_v']; // add any extra query params here

  const url = new URL(window.location.href);
  let modified = false;

  paramsToRemove.forEach(param => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      modified = true;
    }
  });

  if (modified) {
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }
})();
